import React from 'react';
import { connect } from 'react-redux';
// GameGuide imports
import GuideStepContainer from '../layout';
import { nextStep } from '../../../actions/gameGuideActions';

import settings from '../../../../settings';
import StepTitleExit from '../stepTitleExit';

// Game(kit) imports
class GuideStepPlayer extends React.Component {
    onNext = () => {
        const { dispatch } = this.props;
        dispatch(nextStep());
    };

    render() {
        const { id, user } = this.props;

        if (user.loggedIn) {
            return (
                <GuideStepContainer title="TOP! Maak een nieuwe game." id={id}>
                    <div className="interactive-content-container save">
                        <div className="padding" />
                        <img src={`${settings.assetsPath}img/disc-blij-opslaan.png`} alt="Je kan nu opslaan" />
                        <div className="buttons-container">
                            <button type="button" onClick={this.onNext} className="login-warning-green-button">
                                Start stap 1
                            </button>
                        </div>
                    </div>
                </GuideStepContainer>
            );
        }

        const { dispatch } = this.props;

        return (
            <GuideStepContainer titleElement={<StepTitleExit content="!!!! Waarschuwing !!!! Je bent niet ingelogd." />} id={id}>
                <div className="interactive-content-container no-save">
                    <img src={`${settings.assetsPath}img/disc-sad-niet-opslaan.png`} alt="Kan niet opslaan" />
                    <div className="buttons-container">
                        <button type="button" onClick={() => window.gameKit.loginUser(() => dispatch(nextStep()))} className="login-warning-yellow-button">
                            Inloggen
                        </button>
                        <button type="button" onClick={() => window.gameKit.registerUser()} className="login-warning-yellow-button">
                            Account maken
                        </button>
                        <button type="button" onClick={this.onNext} className="login-warning-green-button">
                            Alvast starten
                        </button>
                    </div>
                </div>
            </GuideStepContainer>
        );
    }
}

GuideStepPlayer.defaultProps = {};

const mapDispatchToProps = dispatch => ({
    dispatch
});

const mapStateToProps = state => ({
    user: state.user
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(GuideStepPlayer);
